import { Box, Button, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { AppRoute, hasPermission } from '../../../utils/navigation';
import { useUser } from '../../../hooks/useUser';

import { UnpublishedRegistrationList } from './unpublishedRegistrationList';

export const ExpertRegistrationView = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();

  if (!hasPermission(AppRoute.EXPERT_REGISTRATION, user)) {
    return <Navigate to={`${AppRoute.HOME}`} replace />;
  }
  const navigateToNewXml = () => navigate('/ekspertregistrering/xml/enhet/velg-bygg');
  const navigateToNewJson = () => navigate('/ekspertregistrering/json/enhet/velg-bygg');

  const energimerkeV2025Enabled = window.config.VITE_ENERGIMERKE_V2025_ENABLED;

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap={4}>
        <Typography variant="p">{t('energyAssessment.description_xml')}</Typography>

        <Box gap={3} display="flex" flexDirection="row">
          <Button onClick={navigateToNewXml} aria-label={t('expertRegistrationScreen.startXmlRegistration')}>
            {t('expertRegistrationScreen.startXmlRegistration')}
          </Button>
          {energimerkeV2025Enabled && (
            <Button onClick={navigateToNewJson} aria-label={t('expertRegistrationScreen.startJsonRegistration')}>
              {t('expertRegistrationScreen.startJsonRegistration')}
            </Button>
          )}
        </Box>
      </Box>

      <UnpublishedRegistrationList />
    </Fragment>
  );
};
